/**
 * Verify that our OKLCH colors convert to the correct hex values
 * 
 * OKLCH color space is perceptually uniform, but the conversion can be tricky.
 * This utility helps verify our values are correct.
 */

export const verifyBrandColors = () => {
	// Expected brand colors
	const expectedColors = {
		brandWhite: '#FFFDFD',
		primaryText: '#3A2E2F',
		primaryAction: '#621984',
		primaryLight: '#81479C',
		hexGrid: '#878DDD',
	}

	// OKLCH values we're using
	const oklchValues = {
		brandWhite: 'oklch(0.9997 0.0003 106.87)',
		primaryText: 'oklch(0.35 0.02 350)',
		primaryAction: 'oklch(0.45 0.15 282)',
		primaryLight: 'oklch(0.55 0.08 282)',
		hexGrid: 'oklch(0.65 0.12 265)',
	}

	console.log('Brand Color Verification:')
	console.log('========================')
	
	// Log expected vs OKLCH
	Object.entries(expectedColors).forEach(([name, hex]) => {
		const oklch = oklchValues[name as keyof typeof oklchValues]
		console.log(`${name}:`)
		console.log(`  Expected: ${hex}`)
		console.log(`  OKLCH: ${oklch}`)
	})

	// If running in browser, check computed styles
	if (typeof window !== 'undefined') {
		console.log('\nComputed CSS Values:')
		console.log('===================')
		const root = document.documentElement
		const computedStyle = getComputedStyle(root)
		
		const cssVars = {
			'--background': 'Background',
			'--primary': 'Primary',
			'--secondary': 'Secondary',
			'--accent': 'Accent',
		}
		
		Object.entries(cssVars).forEach(([varName, label]) => {
			const value = computedStyle.getPropertyValue(varName).trim()
			console.log(`${label}: ${value}`)
		})
	}
}

// Correct OKLCH values for HoneyGrid brand colors:
// #FFFDFD = oklch(0.9997 0.0003 106.87)
// #3A2E2F = oklch(0.35 0.02 350)
// #621984 = oklch(0.45 0.15 282)
// #81479C = oklch(0.55 0.08 282)
// #878DDD = oklch(0.65 0.12 265)